import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceEmailsSettingsEntityState} from "../reducers/ecommerce-emails-settings.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceEmailsSettingsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceEmailsSettings.entities[websiteId]);

export const getEcommerceEmailsSettings = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data : [];
  }
);
export const getEcommerceEmailsSettingsFromName = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data.find(item => item.id === "woocommerce_email_from_name") : [];
  }
);
export const getEcommerceEmailsSettingsFromAddress = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data.find(item => item.id === "woocommerce_email_from_address") : [];
  }
);
export const getEcommerceEmailsSettingsFooterText = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data.find(item => item.id === "woocommerce_email_footer_text") : [];
  }
);
export const getEcommerceEmailsSettingsPrimaryColor = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data.find(item => item.id === "woocommerce_email_base_color") : [];
  }
);
export const getEcommerceEmailsSettingsBgColor = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data.find(item => item.id === "woocommerce_email_background_color") : [];
  }
);
export const getEcommerceEmailsSettingsBodyBgColor = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data.find(item => item.id === "woocommerce_email_body_background_color") : [];
  }
);
export const getEcommerceEmailsSettingsTextColor = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => {
    return state?.data ? state.data.find(item => item.id === "woocommerce_email_text_color") : [];
  }
);

export const getEcommerceEmailsSettingsLoading = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => state && state.loading
);

export const getEcommerceEmailsSettingsLoaded = (websiteId: number) => createSelector(getEcommerceEmailsSettingsState(websiteId),
  (state: IEcommerceEmailsSettingsEntityState) => state && state.loaded
);
